import { ReactComponent as TableSortDefault } from '@/common/resource/icon/TableSort/Default.svg';
import { ReactComponent as TableSortDown } from '@/common/resource/icon/TableSort/Down.svg';
import { ReactComponent as TableSortUp } from '@/common/resource/icon/TableSort/Up.svg';

import { ReactComponent as ArrowDown } from '@/common/resource/icon/Arrow-down.svg';
import { ReactComponent as ArrowFillDown } from '@/common/resource/icon/Arrow-fill-down.svg';
import { ReactComponent as ArrowFillLeft } from '@/common/resource/icon/Arrow-fill-left.svg';
import { ReactComponent as ArrowFillRight } from '@/common/resource/icon/Arrow-fill-right.svg';
import { ReactComponent as ArrowFillUp } from '@/common/resource/icon/Arrow-fill-up.svg';
import { ReactComponent as ArrowLeft } from '@/common/resource/icon/Arrow-left.svg';
import { ReactComponent as ArrowRight } from '@/common/resource/icon/Arrow-right.svg';
import { ReactComponent as ArrowTop } from '@/common/resource/icon/Arrow-top.svg';
import { ReactComponent as Attention } from '@/common/resource/icon/Attention.svg';
import { ReactComponent as Audience } from '@/common/resource/icon/Audience.svg';

import { ReactComponent as Back } from '@/common/resource/icon/Back.svg';
import { ReactComponent as Bold } from '@/common/resource/icon/Bold.svg';

import { ReactComponent as Calendar } from '@/common/resource/icon/Calendar.svg';
import { ReactComponent as Capslock } from '@/common/resource/icon/Capslock.svg';
import { ReactComponent as Check } from '@/common/resource/icon/Check.svg';
import { ReactComponent as CloseCircle } from '@/common/resource/icon/Close-circle.svg';
import { ReactComponent as Close } from '@/common/resource/icon/Close.svg';
import { ReactComponent as Compass } from '@/common/resource/icon/Compass.svg';
import { ReactComponent as Copy } from '@/common/resource/icon/Copy.svg';
import { ReactComponent as Dashboard } from '@/common/resource/icon/Dashboard.svg';
import { ReactComponent as Delete } from '@/common/resource/icon/Delete.svg';
import { ReactComponent as Download } from '@/common/resource/icon/Download.svg';
import { ReactComponent as Drag } from '@/common/resource/icon/Drag.svg';

import { ReactComponent as Edit } from '@/common/resource/icon/Edit.svg';
import { ReactComponent as EyeOff } from '@/common/resource/icon/Eye-off.svg';
import { ReactComponent as EyeOn } from '@/common/resource/icon/Eye-on.svg';
import { ReactComponent as FileText } from '@/common/resource/icon/File-text.svg';
import { ReactComponent as FilterOffDot } from '@/common/resource/icon/Filter-off-dot.svg';
import { ReactComponent as FilterOff } from '@/common/resource/icon/Filter-off.svg';
import { ReactComponent as Guide } from '@/common/resource/icon/Guide.svg';

import { ReactComponent as Hash } from '@/common/resource/icon/Hash.svg';
import { ReactComponent as Home } from '@/common/resource/icon/home.svg';
import { ReactComponent as Image } from '@/common/resource/icon/Image.svg';
import { ReactComponent as Info } from '@/common/resource/icon/Info.svg';
import { ReactComponent as QuestionMark } from '@/common/resource/icon/Question-mark.svg';
import { ReactComponent as Italic } from '@/common/resource/icon/Italic.svg';

import { ReactComponent as Link } from '@/common/resource/icon/Link.svg';
import { ReactComponent as Loader } from '@/common/resource/icon/Loder.svg';

import { ReactComponent as Message } from '@/common/resource/icon/Message.svg';
import { ReactComponent as More } from '@/common/resource/icon/More.svg';
import { ReactComponent as PanelLeftClose } from '@/common/resource/icon/Panel-left-close.svg';
import { ReactComponent as PanelLeftOpen } from '@/common/resource/icon/Panel-left-open.svg';
import { ReactComponent as Person } from '@/common/resource/icon/Person.svg';
import { ReactComponent as Plus } from '@/common/resource/icon/Plus.svg';
import { ReactComponent as Reset } from '@/common/resource/icon/Reset.svg';
import { ReactComponent as Result } from '@/common/resource/icon/Result.svg';
import { ReactComponent as Search } from '@/common/resource/icon/Search.svg';
import { ReactComponent as Select } from '@/common/resource/icon/Select.svg';
import { ReactComponent as Send } from '@/common/resource/icon/Send.svg';
import { ReactComponent as Settings } from '@/common/resource/icon/Settings.svg';
import { ReactComponent as Sort } from '@/common/resource/icon/Sort.svg';
import { ReactComponent as Stop } from '@/common/resource/icon/Stop.svg';

import { ReactComponent as TextCenter } from '@/common/resource/icon/Text-center.svg';
import { ReactComponent as TextLeft } from '@/common/resource/icon/Text-left.svg';
import { ReactComponent as TextRight } from '@/common/resource/icon/Text-right.svg';
import { ReactComponent as Underline } from '@/common/resource/icon/Underline.svg';
import { ReactComponent as Unlock } from '@/common/resource/icon/Unlock.svg';
import { ReactComponent as Upload } from '@/common/resource/icon/Upload.svg';
import { ReactComponent as User } from '@/common/resource/icon/User.svg';
import { ReactComponent as Video } from '@/common/resource/icon/Video.svg';
import { ReactComponent as Writing } from '@/common/resource/icon/Writing.svg';

const Icon = {
  TableSortDefault,
  TableSortDown,
  TableSortUp,
  ArrowDown,
  ArrowFillDown,
  ArrowFillLeft,
  ArrowFillRight,
  ArrowFillUp,
  ArrowLeft,
  ArrowRight,
  ArrowTop,
  Attention,
  Audience,
  Back,
  Bold,
  Calendar,
  Capslock,
  Check,
  CloseCircle,
  Close,
  Compass,
  Copy,
  Dashboard,
  Delete,
  Download,
  Drag,
  Edit,
  EyeOff,
  EyeOn,
  FileText,
  FilterOffDot,
  FilterOff,
  Guide,
  Hash,
  Home,
  Image,
  Info,
  QuestionMark,
  Italic,
  Link,
  Loader,
  Message,
  More,
  PanelLeftClose,
  PanelLeftOpen,
  Person,
  Plus,
  Reset,
  Result,
  Search,
  Select,
  Send,
  Settings,
  Sort,
  Stop,
  TextCenter,
  TextLeft,
  TextRight,
  Underline,
  Unlock,
  Upload,
  User,
  Video,
  Writing,
};

export default Icon;
